import React from 'react'
import PropTypes from 'prop-types'
import { Card, Divider } from 'pcln-design-system'
import ProductTabs from './ProductTabs'
import TabHeader from './TabHeader'

const SearchBoxHeader = ({ currentTab = 'hotels' }) =>
  <Card borderWidth={0} borderRadius={6} boxShadowSize='md' color='background.light'>
    <TabHeader currentTab={currentTab} />
    <Divider m={0} />
    <ProductTabs currentTab={currentTab} />
  </Card>

SearchBoxHeader.propTypes = {
  currentTab: PropTypes.string
}

export default SearchBoxHeader
